import Header from "../../components/shared/Header";
import "../../styles/shared/Plans.scss";
import HeroImage from "../../images/governance.png";
import SolutionImage1 from "../../images/NDC.png";
import SolutionImage2 from "../../images/Frame 1618868405.png";
import SolutionImage3 from "../../images/verification.png";
import SolutionImage4 from "../../images/SolutionImage3.png";
import SolutionImage5 from "../../images/efficiency.png";
import Focus from "../../images/we team.png";
import { useEffect, useState } from "react";
import GreenLogo from "../../images/Group 32.png";
import { useNavigate } from "react-router-dom";
import Footer from "../../components/shared/Footer";
import BasicCollaborators from "../../components/shared/BasicCollaborators.jsx";
import GovernanceFaq from "../../components/NewLandingPage/GoveranceFaq.jsx";

export default function Governance() {
  const navigate = useNavigate();
  const [type, setType] = useState("tracking");
  const [planVideo, setplanVideo] = useState(false);
  const [openFaq, setOpenFaq] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);

    const nextBtn = document.querySelector(".feedback__inner__group__svg-group__next");
    const prevBtn = document.querySelector(".feedback__inner__group__svg-group__prev");
    const slider = document.querySelector(".feedback__inner__cards");
    const card = document.querySelector(".feedback__inner__cards__card");
    let itemDimensions = card.getBoundingClientRect();
    let amountToSlide = (itemDimensions.width + 24) * 3;

    nextBtn.addEventListener("click", () => {
      slider.scrollLeft += amountToSlide;
      console.log(
        'nextBtn', nextBtn,
        'prevBtn', prevBtn,
        'slider', slider,
        'card', card,
        'itemDimensions', itemDimensions,
        'amountToSlide', amountToSlide
      );
    });

    prevBtn.addEventListener("click", () => {
      slider.scrollLeft -= amountToSlide;
    });

  }, [])

  return (
    <div className="plans">
      <Header />
      <div className="hero">
        <div className="hero__inner">
          <div className="hero__inner__title">
            CloseCarbon <span>Governance</span>
          </div>
          <div className="hero__inner__subtitle">
            Tracking NDC value. Verification. Validation. Carbon incentive.{" "}
          </div>
          <div className="hero__inner__price">
            Starting at ₦0.00 <span>Free</span>
          </div>
          <div className="hero__inner__button-group">
            <button onClick={() => navigate('/template/governance')}>Choose plan</button>
            <button
             onClick={() => {
              window.open("https://youtu.be/On9PHYLfZOk?si=Wtdk1jT5j71VwzFl", "_blank", "noopener,noreferrer");
            }}
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.155 13.7501C3.96313 13.7497 3.77466 13.6994 3.60812 13.6041C3.23312 13.3916 3 12.9791 3 12.5313V3.46881C3 3.01974 3.23312 2.60849 3.60812 2.39599C3.77863 2.298 3.97232 2.24761 4.16896 2.25009C4.36559 2.25256 4.55796 2.30781 4.72594 2.41006L12.4712 7.04631C12.6327 7.14752 12.7657 7.28807 12.858 7.45479C12.9502 7.6215 12.9986 7.8089 12.9986 7.99943C12.9986 8.18996 12.9502 8.37736 12.858 8.54408C12.7657 8.71079 12.6327 8.85134 12.4712 8.95256L4.72469 13.5901C4.55278 13.694 4.35588 13.7493 4.155 13.7501Z"
                  fill="#0FA958"
                />
              </svg>
              Watch now
            </button>
          </div>

          <img loading="lazy" className="hero__inner__img" src={HeroImage} alt="" />
        </div>
      </div>
      <div className="solution">
        <div className="solution__title">
          The <span>solution</span> you need for the sustainability <br></br> you want
        </div>
        <div className="solution__subtitle">
         Built for governments and institutions managing climate commitments, enabling real-time NDC tracking, credible validation, and transparent carbon incentive systems <br />
          {/* <span>- LeadGravel</span> */}
        </div>
        <div className="solution__grid">
          <div className="solution__grid__nav">
            <div
              className={
                type === "tracking"
                  ? "solution__grid__nav__item solution__grid__nav__item-active"
                  : "solution__grid__nav__item"
              }
              onClick={() => setType("tracking")}
            >
              <div className="solution__grid__nav__item__title">Downloadable Carbon emission report</div>
              {type === "tracking" && (
                <div className="solution__grid__nav__item__subtitle">
Monitor Nationally Determined Contribution (NDC) performance and climate targets in real time. Gain clear visibility into emissions trends, reductions achieved, and progress toward national sustainability commitments. </div>              )}
            </div>
            <div
              className={
                type === "credit"
                  ? "solution__grid__nav__item solution__grid__nav__item-active"
                  : "solution__grid__nav__item"
              }
              onClick={() => setType("credit")}
            >
              <div className="solution__grid__nav__item__title">
Carbon Incentive (CCRTs)              </div>
              {type === "credit" && (
                <div className="solution__grid__nav__item__subtitle">
                  Earn CloseCarbon Reduction Tonnes (CCRT) for verified emission reductions. Each tonne of CO₂ or CO₂e reduced is converted into a transparent, traceable carbon asset.             </div>
              )}
            </div>
            <div
              className={
                type === "verification"
                  ? "solution__grid__nav__item solution__grid__nav__item-active"
                  : "solution__grid__nav__item"
              }
              onClick={() => setType("verification")}
            >
              <div className="solution__grid__nav__item__title">
                Verification
              </div>
              {type === "verification" && (
                <div className="solution__grid__nav__item__subtitle">
Emissions and reduction data undergo independent review by certified verifiers to ensure accuracy, reliability, and compliance with established methodologies and standards.                </div>
              )}
            </div>
            <div
              className={
                type === "insights"
                  ? "solution__grid__nav__item solution__grid__nav__item-active"
                  : "solution__grid__nav__item"
              }
              onClick={() => setType("insights")}
            >
              <div className="solution__grid__nav__item__title">
   Automated Reporting & Insights
              </div>
              {type === "insights" && (
                <div className="solution__grid__nav__item__subtitle">Generate structured, policy-ready reports on emissions performance and reductions. Support evidence-based decision-making and transparent climate governance     </div>
              )}
              
            </div>
          
          </div>
          {type === "tracking" && (
            <img loading="lazy" src={SolutionImage1} className="solution__grid__img"loading='lazy'/>
          )}
          {type === "credit" && (
            <img loading="lazy" src={SolutionImage2} className="solution__grid__img"loading='lazy'/>
          )}
          {type === "verification" && (
            <img loading="lazy" src={SolutionImage3} className="solution__grid__img"loading='lazy'/>
          )}
          {type === "insights" && (
            <img loading="lazy" src={SolutionImage5} className="solution__grid__img"loading='lazy'/>
          )}
          {type === "Incentive" && (
            <img loading="lazy" src={SolutionImage4} className="solution__grid__img"loading='lazy'/>
          )}
        </div>
      </div>
      <div className="feedback">
        <div className="feedback__inner">
          <div className="feedback__inner__group">
            <div className="feedback__inner__group__title">
              Feedback from our customers
            </div>
            <div className="feedback__inner__group__subtitle">
              We’re trusted by several organizations
            </div>
            <div className="feedback__inner__group__svg-group">
              <div className="feedback__inner__group__svg-group__prev">
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M0.292892 7.29289C-0.0976315 7.68342 -0.0976315 8.31658 0.292892 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292892 7.29289ZM17 7L1 7V9L17 9V7Z" />
                </svg>
              </div>

              <div className="feedback__inner__group__svg-group__next">
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M16.7071 8.70711C17.0976 8.31658 17.0976 7.68342 16.7071 7.29289L10.3431 0.928932C9.95262 0.538408 9.31946 0.538408 8.92893 0.928932C8.53841 1.31946 8.53841 1.95262 8.92893 2.34315L14.5858 8L8.92893 13.6569C8.53841 14.0474 8.53841 14.6805 8.92893 15.0711C9.31946 15.4616 9.95262 15.4616 10.3431 15.0711L16.7071 8.70711ZM0 9H16V7H0L0 9Z" />
                </svg>
              </div>
            </div>
          </div>
          <div className="feedback__inner__cards">
            <div className="feedback__inner__cards__card">
              <div className="feedback__inner__cards__card__cover"></div>

              <div className="feedback__inner__cards__card__title">
              The Governance Plan was the right choice for us due to its structured validation process. Working with verifiers gave our data more credibility, which matters for ESG reporting and investor transparency. It's rigorous and reliable.              </div>
              <div className="feedback__inner__cards__card__subtitle">
              Laura Bennett
              </div>
              <div></div>
            </div>
            <div className="feedback__inner__cards__card">
              <div className="feedback__inner__cards__card__cover"></div>

              <div className="feedback__inner__cards__card__title">
              I've been using governance plan for a month now, and I'm already seeing positive changes in my carbon footprint. The real-time tracking feature is especially helpful in keeping me accountable.              </div>
              <div className="feedback__inner__cards__card__subtitle">
              Samuel Okon
              </div>
              <div></div>
            </div>
            <div className="feedback__inner__cards__card">
              <div className="feedback__inner__cards__card__cover"></div>

              <div className="feedback__inner__cards__card__title">
              As a multinational company, we needed a plan that supports accountability at every level. The validation and reporting features in the Governance Plan helped us align with international compliance standards. It’s built for trust.              </div>
              <div className="  feedback__inner__cards__card__subtitle ">
         Temi Balogun
              </div>
              <div></div>
            </div>
            {/* <div className="feedback__inner__cards__card">
              <div className="feedback__inner__cards__card__cover"></div>

              <div className="feedback__inner__cards__card__title">
              CloseCarbon's governance plan made it incredibly easy for me to track my carbon emissions. I'm impressed with the simplicity and effectiveness of the tools provided.
              </div>
              <div className="feedback__inner__cards__card__subtitle">
                Samuel
              </div>
              <div>LS Truval</div>
            </div>
            <div className="feedback__inner__cards__card">
              <div className="feedback__inner__cards__card__cover"></div>

              <div className="feedback__inner__cards__card__title">
              I've been using CloseCarbon's governance plan for a month now, and I'm already seeing positive changes in my carbon footprint. The real-time tracking feature is especially helpful in keeping me accountable.
              </div>
              <div className="feedback__inner__cards__card__subtitle">
                Samuel
              </div>
              <div>LS Truval</div>
            </div>
            <div className="feedback__inner__cards__card">
              <div className="feedback__inner__cards__card__cover"></div>

              <div className="feedback__inner__cards__card__title">
              This governance plan makes me feel more empowered to make sustainable choices in my daily life. The user-friendly interface have been instrumental in guiding me towards a greener lifestyle.
              </div>
              <div className="feedback__inner__cards__card__subtitle">
                Samuel
              </div>
              <div>LS Truval</div>
            </div>
             */}
          </div>
        </div>
      </div>

      <div className="unlock">
        <div className="unlock__card1">
          <div className="unlock__card1__title">
            Unlock the potential of <br/> 
            <span className="text-[#0D924F] font-bold">CloseCarbon Governance plan</span>
          </div>
          <div className="unlock__card1__subtitle">
            Whether you're just starting your sustainability journey or seeking
            to deepen your commitment, the governance plan provides the
            foundation you need to take meaningful steps towards environmental
            stewardship.{" "}
          </div>
          <img loading="lazy" className="unlock__card1__img" src={Focus} alt="" />
        </div>
        <div className="unlock__card2">
          <div className="unlock__card2__flex">
            <img loading="lazy" src={GreenLogo} />
            <div>
              <div className="text-[20px] font-semibold">Governance</div>
              <div className="text-[#898989]">NDC Value </div>
            </div>
               <div className="text-[#0D924F] text-6xl font-bold ml-72"> ₦0.00
            <div className="text-end mt-2 text-gray-500">Free</div>

               </div>
           
          </div>
          <div className="unlock__card2__price">
           
          </div>
          <div className="unlock__card2__divider"></div>
          <div className="unlock__card2__more-info">
            <div className="unlock__card2__more-info__title">How it works:</div>
            <div className="unlock__card2__more-info__flex">
        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="13" cy="13" r="13" fill="#F0F2F5"/>
<path d="M19.4974 12.998V16.248H6.4974V7.58138H10.2891V6.49805H6.4974C6.21008 6.49805 5.93453 6.61218 5.73136 6.81535C5.5282 7.01851 5.41406 7.29406 5.41406 7.58138V16.248C5.41406 16.5354 5.5282 16.8109 5.73136 17.0141C5.93453 17.2172 6.21008 17.3314 6.4974 17.3314H10.8307V19.498H8.66406V20.5814H17.3307V19.498H15.1641V17.3314H19.4974C19.7847 17.3314 20.0603 17.2172 20.2634 17.0141C20.4666 16.8109 20.5807 16.5354 20.5807 16.248V12.998H19.4974ZM14.0807 19.498H11.9141V17.3314H14.0807V19.498Z" fill="#475367"/>
<path d="M14.0807 14.0821H14.0753C13.9586 14.0809 13.8454 14.042 13.7526 13.9712C13.6598 13.9005 13.5923 13.8016 13.5602 13.6894L12.589 10.2904H10.2891V9.20709H12.9974C13.1151 9.20703 13.2297 9.24532 13.3237 9.31618C13.4177 9.38704 13.4861 9.4866 13.5185 9.5998L14.1002 11.6365L15.7301 6.33897C15.765 6.22886 15.8338 6.13261 15.9267 6.06402C16.0197 5.99542 16.1319 5.95799 16.2474 5.95709C16.3615 5.95538 16.4732 5.99049 16.5658 6.05723C16.6584 6.12397 16.727 6.21878 16.7614 6.32759L17.7207 9.20709H20.5807V10.2904H17.3307C17.217 10.2905 17.1061 10.2547 17.0139 10.1882C16.9216 10.1217 16.8526 10.0278 16.8167 9.91992L16.268 8.27326L14.5986 13.6997C14.5645 13.8104 14.4958 13.9073 14.4026 13.9762C14.3094 14.045 14.1966 14.0821 14.0807 14.0821Z" fill="#475367"/>
</svg>


              <div>
              Tracking NDC value in real-time: ensuring transparent and effective management of your sustainability goals.
              </div>
            </div>
            <div className="unlock__card2__more-info__flex">
            <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="13" cy="13" r="13" fill="#F0F2F5"/>
<path d="M7.03843 7.04102C7.03843 6.61004 7.20964 6.19671 7.51438 5.89197C7.81913 5.58722 8.23246 5.41602 8.66343 5.41602H14.1733C14.604 5.41625 15.0171 5.58751 15.3216 5.89214L18.4795 9.04897C18.7841 9.35374 18.9552 9.76699 18.9551 10.1978V18.9577C18.9551 19.3887 18.7839 19.802 18.4791 20.1067C18.1744 20.4115 17.7611 20.5827 17.3301 20.5827H14.053C14.0913 20.3951 14.0893 20.2016 14.0473 20.0149C14.0053 19.8281 13.9241 19.6524 13.8093 19.4993H17.3301C17.4738 19.4993 17.6115 19.4423 17.7131 19.3407C17.8147 19.2391 17.8718 19.1013 17.8718 18.9577V10.8327H15.1634C14.7325 10.8327 14.3191 10.6615 14.0144 10.3567C13.7096 10.052 13.5384 9.63866 13.5384 9.20768V6.49935H8.66343C8.51977 6.49935 8.382 6.55642 8.28042 6.658C8.17883 6.75958 8.12177 6.89736 8.12177 7.04102V12.2226C7.74839 12.2726 7.38378 12.3744 7.03843 12.5248V7.04102ZM15.1634 9.74935H17.6475L14.6218 6.7236V9.20768C14.6218 9.35134 14.6788 9.48912 14.7804 9.5907C14.882 9.69228 15.0198 9.74935 15.1634 9.74935ZM8.66343 19.4993C9.36543 19.4993 10.0154 19.2773 10.5463 18.8981L12.343 20.6948C12.4451 20.7935 12.582 20.8481 12.724 20.8468C12.866 20.8456 13.0019 20.7886 13.1023 20.6882C13.2027 20.5878 13.2597 20.4519 13.2609 20.3099C13.2622 20.1679 13.2076 20.0311 13.1089 19.9289L11.3127 18.1327C11.7349 17.539 11.9454 16.8206 11.9103 16.0928C11.8752 15.3651 11.5966 14.6703 11.1193 14.1199C10.6419 13.5695 9.99345 13.1955 9.278 13.0579C8.56255 12.9202 7.82161 13.027 7.17412 13.361C6.52663 13.695 6.01015 14.2369 5.70758 14.8996C5.40501 15.5624 5.33391 16.3076 5.5057 17.0156C5.67748 17.7237 6.08218 18.3534 6.65483 18.8039C7.22748 19.2543 7.93487 19.4992 8.66343 19.4993ZM8.66343 18.416C8.0888 18.416 7.5377 18.1877 7.13137 17.7814C6.72504 17.3751 6.49677 16.824 6.49677 16.2493C6.49677 15.6747 6.72504 15.1236 7.13137 14.7173C7.5377 14.311 8.0888 14.0827 8.66343 14.0827C9.23807 14.0827 9.78917 14.311 10.1955 14.7173C10.6018 15.1236 10.8301 15.6747 10.8301 16.2493C10.8301 16.824 10.6018 17.3751 10.1955 17.7814C9.78917 18.1877 9.23807 18.416 8.66343 18.416Z" fill="#475367"/>
</svg>


              <div>
              Verification: ensuring the accuracy of your reduction data is established.
              </div>
            </div>
            <div className="unlock__card2__more-info__flex">
   <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="13" cy="13" r="13" fill="#F0F2F5"/>
<path d="M5.41406 8.26042C5.41406 7.79353 5.59953 7.34576 5.92968 7.01561C6.25982 6.68547 6.70759 6.5 7.17448 6.5H18.8203C19.2872 6.5 19.735 6.68547 20.0651 7.01561C20.3953 7.34576 20.5807 7.79353 20.5807 8.26042V16.1146C20.5807 16.5815 20.3953 17.0292 20.0651 17.3594C19.735 17.6895 19.2872 17.875 18.8203 17.875H11.6432V16.8496L11.6774 16.7917H18.8203C19.1941 16.7917 19.4974 16.4883 19.4974 16.1146V8.26042C19.4974 7.88667 19.1941 7.58333 18.8203 7.58333H7.17448C6.80073 7.58333 6.4974 7.88667 6.4974 8.26042V11.6117C6.07993 11.8527 5.71226 12.1711 5.41406 12.5499V8.26042ZM11.3724 14.8958C11.3724 15.686 11.0585 16.4437 10.4998 17.0024C9.94112 17.5611 9.18335 17.875 8.39323 17.875C7.6031 17.875 6.84534 17.5611 6.28664 17.0024C5.72794 16.4437 5.41406 15.686 5.41406 14.8958C5.41406 14.1057 5.72794 13.3479 6.28664 12.7892C6.84534 12.2305 7.6031 11.9167 8.39323 11.9167C9.18335 11.9167 9.94112 12.2305 10.4998 12.7892C11.0585 13.3479 11.3724 14.1057 11.3724 14.8958ZM10.8307 17.8003C10.1485 18.3746 9.28502 18.6889 8.39323 18.6875C7.50144 18.6889 6.63794 18.3746 5.95573 17.8003V20.0417C5.95575 20.1382 5.98159 20.233 6.03057 20.3163C6.07956 20.3995 6.1499 20.4681 6.23431 20.515C6.31873 20.5619 6.41415 20.5854 6.51069 20.583C6.60723 20.5807 6.70138 20.5525 6.7834 20.5015L8.39323 19.4995L10.0031 20.5015C10.0851 20.5526 10.1793 20.5807 10.2759 20.583C10.3725 20.5854 10.4679 20.5619 10.5524 20.5149C10.6368 20.4679 10.7071 20.3992 10.7561 20.3159C10.805 20.2326 10.8308 20.1377 10.8307 20.0411V17.8003ZM8.66406 10.2917C8.66406 10.148 8.72113 10.0102 8.82271 9.90865C8.92429 9.80707 9.06207 9.75 9.20573 9.75H16.7891C16.9327 9.75 17.0705 9.80707 17.1721 9.90865C17.2737 10.0102 17.3307 10.148 17.3307 10.2917C17.3307 10.4353 17.2737 10.5731 17.1721 10.6747C17.0705 10.7763 16.9327 10.8333 16.7891 10.8333H9.20573C9.06207 10.8333 8.92429 10.7763 8.82271 10.6747C8.72113 10.5731 8.66406 10.4353 8.66406 10.2917ZM13.5391 13.5417C13.3954 13.5417 13.2576 13.5987 13.156 13.7003C13.0545 13.8019 12.9974 13.9397 12.9974 14.0833C12.9974 14.227 13.0545 14.3648 13.156 14.4664C13.2576 14.5679 13.3954 14.625 13.5391 14.625H16.7891C16.9327 14.625 17.0705 14.5679 17.1721 14.4664C17.2737 14.3648 17.3307 14.227 17.3307 14.0833C17.3307 13.9397 17.2737 13.8019 17.1721 13.7003C17.0705 13.5987 16.9327 13.5417 16.7891 13.5417H13.5391Z" fill="#475367"/>
</svg>


              <div>
     Validation: ensuring the accuracy of assumptions and methods supporting future activity outcomes.
              </div>
            </div>
            <div className="unlock__card2__more-info__flex">
          <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="13" cy="13" r="13" fill="#F0F2F5"/>
<path d="M19.451 16.4917C19.0552 14.129 17.9239 11.9514 16.2183 10.2691C15.845 9.90578 15.6586 9.72451 15.2462 9.55695C14.8338 9.38867 14.4792 9.38867 13.7707 9.38867H12.2136C11.5051 9.38867 11.1505 9.38867 10.7381 9.55695C10.3265 9.72451 10.1387 9.90578 9.76601 10.2691C8.06045 11.9514 6.92919 14.129 6.53334 16.4917C6.18162 18.6136 8.13884 20.222 10.3257 20.222H15.6586C17.8462 20.222 19.8042 18.6136 19.4503 16.4917" stroke="#475367" stroke-width="1.08333" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9.56856 7.54173C9.41906 7.32507 9.20311 7.0304 9.64944 6.96395C10.1081 6.89462 10.584 7.20807 11.0506 7.20229C11.4716 7.19579 11.6861 7.00873 11.9172 6.74151C12.1599 6.46057 12.5354 5.77734 12.9941 5.77734C13.4527 5.77734 13.8282 6.46057 14.0709 6.74151C14.302 7.00873 14.5165 7.19651 14.9376 7.20157C15.4041 7.20879 15.8801 6.89462 16.3387 6.96323C16.785 7.0304 16.5691 7.32434 16.4196 7.54101L15.7464 8.52251C15.4576 8.9414 15.3138 9.15084 15.0119 9.27001C14.7101 9.38918 14.3208 9.38846 13.5415 9.38846H12.4466C11.6666 9.38846 11.2773 9.38846 10.9762 9.27001C10.675 9.15157 10.5306 8.94068 10.2417 8.52179L9.56856 7.54173Z" stroke="#475367" stroke-width="1.08333" stroke-linejoin="round"/>
<path d="M14.1674 13.6632C14.0114 13.0862 13.2162 12.5662 12.2621 12.9554C11.3081 13.3447 11.1571 14.5963 12.5994 14.7299C13.2523 14.7899 13.677 14.6599 14.0663 15.0275C14.4563 15.3944 14.5285 16.4163 13.5325 16.6915C12.538 16.9667 11.5522 16.5369 11.4453 15.9259M12.8782 12.2715V12.8211M12.8782 16.776V17.3278" stroke="#475367" stroke-width="1.08333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


              <div>Earn CloseCarbon credit.</div>
            </div>

            <button
              className="hero-btn mt-10 group text-[16px] text-white flex justify-center items-center border-2 border-[#E4E7EC] py-[6px] gap-[10px] w-[132px]  h-[56px] bg-[#0D924F] rounded-[8px] hover:bg-[#0d713f] transition-all cursor-pointer  hover:-translate-y-0.5 "
              onClick={() => navigate('/template/governance')}
            >
              Choose plan
            </button>
          </div>
        </div>
      </div>
     <div className="bg-[#D3EEE0]">
      <GovernanceFaq/>

      </div>
 
       <BasicCollaborators />
      <Footer />

    </div>
  );
}
